export default __webpack_public_path__ + "static/media/hellocourier_logo.778ab587.png";